import { useEffect } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import UsageTracker from '../../../utils/UsageTracker';
import { ACADEMY_ONBOARDING_SECTION_IDS_SET } from '../constants/sectionAnchors';
const RESETTLE_WINDOW_MS = 3000;
const RESETTLE_DEBOUNCE_MS = 150;
export default function useScrollToSectionOnLoad() {
  const {
    search,
    hash
  } = useLocation();
  useEffect(() => {
    const targetId = new URLSearchParams(search).get('section') || hash.replace(/^#/, '');
    if (!targetId || !ACADEMY_ONBOARDING_SECTION_IDS_SET.has(targetId)) {
      return undefined;
    }
    let hasTracked = false;
    let debounceId;
    const scrollToTarget = () => {
      const element = document.getElementById(targetId);
      if (!element) return;
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      if (!hasTracked) {
        hasTracked = true;
        UsageTracker.trackStandalone('Learning Center Interaction', {
          action: `onboarding-deeplink-${targetId}`
        });
      }
    };

    // The target section may not be in the DOM yet (sections load async), and
    // sections rendered above it can appear late and shift the layout down. So
    // attempt an initial scroll, then re-settle on DOM changes for a bounded
    // window until the layout stabilizes.
    scrollToTarget();
    const observer = new MutationObserver(() => {
      if (debounceId !== undefined) {
        window.clearTimeout(debounceId);
      }
      debounceId = window.setTimeout(scrollToTarget, RESETTLE_DEBOUNCE_MS);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    const stopId = window.setTimeout(() => {
      observer.disconnect();
    }, RESETTLE_WINDOW_MS);
    return () => {
      observer.disconnect();
      window.clearTimeout(stopId);
      if (debounceId !== undefined) {
        window.clearTimeout(debounceId);
      }
    };
  }, [search, hash]);
}